document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".custom-great-to-know-container .ct-gt-item a").forEach(item => {
        item.addEventListener("click", function() {
            if(this.closest(".custom-great-to-know-container").querySelector(".great-popup-container").classList.contains("active")) {
                item.classList.remove("active");
                document.querySelector("body.template-product").style.overflow= "auto";
            }
            this.closest(".custom-great-to-know-container").querySelector(".great-popup-container").classList.add("active");
            document.querySelector("body.template-product").style.overflow = "hidden";
        })
    })

    // document.querySelector(".custom-great-to-know-container .great-popup-container").addEventListener("click", function() {
    //     this.classList.remove("active");
    //     document.querySelector("body.template-product").style.overflow = "auto";
    // })

    document.querySelector(".pop-up__title .pop-up__close").addEventListener("click", function() {
        this.closest(".custom-great-to-know-container .great-popup-container").classList.remove("active");
        document.querySelector("body.template-product").style.overflow = "auto";
    })
})